import styled, { css } from 'styled-components';
import { gridPattern } from '../../styles/gridStyles';

interface HeaderWrapperProps {
  hasAds: boolean;
}

interface HeaderContainerProps {
  isShimmering: boolean;
}

export const HeaderWrapper = styled.div<HeaderWrapperProps>`
  ${gridPattern}

  ${({ hasAds }) =>
    !hasAds &&
    css`
      display: none;
      visibility: hidden;
      ${HeaderFilterContainer} {
        display: none;
        visibility: hidden;
      }
    `}

  @media (min-width: 425px) {
    ${({ hasAds }) =>
      !hasAds &&
      css`
        display: grid;
        visibility: visible;
      `}
  }
`;

export const HeaderContainer = styled.div<HeaderContainerProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  ${({ isShimmering }) =>
    isShimmering &&
    css`
      div {
        margin-top: 20px;
      }
    `}

  button {
    flex-direction: row-reverse;
    span {
      display: none;
      @media (min-width: 768px) {
        display: block;
      }
    }
  }
`;

export const HeaderFilterContainer = styled.div`
  margin: 0;
  padding: 0;
`;

export const HeaderBreadcrumbsContainer = styled.div`
  display: none;

  & > button {
    padding: 0;
  }
  @media (min-width: 768px) {
    display: block;
  }
`;

export const ContentWrapper = styled.div`
  ${gridPattern}

  padding-block: 40px;
  display: flex;
  flex-direction: column;
  gap: 40px !important;
  justify-content: center;
  align-items: center;
`;

export const ActionWrapper = styled.div`
  ${gridPattern}
  margin-top: 28px;
  margin-bottom: -24px;
  justify-content: flex-start;
  > button {
    width: fit-content;
    flex-direction: row-reverse;
    grid-column: span 6;
  }
`;
